import { useEffect } from "react";

import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { toggleCustomKeyIssueForm } from "domains/customKeyIssue/actions";
import { AddCustomKeyIssue } from "domains/customKeyIssue/components/AddCustomKeyIssue";
import { getCustomKeyIssueIsActiveForm, getCustomKeyIssueIsUploading } from "domains/customKeyIssue/selectors";
import { popModalScreen } from "domains/modal/actions";
import { ModalHeader } from "domains/modal/components/ModalHeader";

export const AddCustomDimensionModal = () => {
  const dispatch = useDispatch();
  const translate = useTranslate();
  const isCustomKeyIssueFormOpen = useSelector(getCustomKeyIssueIsActiveForm);
  const isUploading = useSelector(getCustomKeyIssueIsUploading);

  useEffect(
    () => () => {
      dispatch(toggleCustomKeyIssueForm({ isActive: false }));
    },
    [dispatch],
  );

  useEffect(() => {
    if (!isCustomKeyIssueFormOpen && !isUploading) {
      dispatch(popModalScreen());
    }
  }, [dispatch, isCustomKeyIssueFormOpen, isUploading]);

  return (
    <>
      <ModalHeader title={translate("app.custom_key_issue.create")} />
      <AddCustomKeyIssue />
    </>
  );
};
